//resources for logged user, resource exist redirect to page else redirect to default

export const onLogRedirectTo = () => {
    // if (resourcesArray.find((item) => item.name === 'dashboard')) {
    //   window.location = '/dashboard';
    // } else {
    //   window.location = '/profile';
    // }
    window.location = '/dashboard';
  };
  
